import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-manage-challenges-sidebar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './manage-challenges-sidebar.component.html',
  styleUrl: './manage-challenges-sidebar.component.scss',
})
export class ManageChallengesSidebarComponent {
  @Input() activeTab: string = 'overview';

  /** Toggle state for expandable items (e.g. All Challenges). Key = menu item key. */
  expandedMenuKeys: { [key: string]: boolean } = {};

  menuItems = [
    { label: 'Overview', tab: 'overview', key: 'overview' },
    {
      label: 'All Challenges',
      tab: 'all',
      key: 'all',
      subsections: [
        { label: 'New Challenges', tab: 'new-challenges', key: 'new-challenges' },
        { label: 'Under Evaluation', tab: 'ongoing-challenges', key: 'ongoing-challenges' },
        { label: 'Past Challenges', tab: 'past-challenges', key: 'past-challenges' }
      ]
    },
  ];

  personaliseItems = [
    { label: 'Challenges Submitted', tab: 'your-competitions', key: 'your-competitions' },
    { label: 'Bookmarks', tab: 'bookmarked', key: 'bookmarked' }
  ];

  get overviewItem() {
    return this.menuItems[0];
  }

  get allChallengesItem() {
    return this.menuItems[1];
  }

  constructor(private router: Router) {}

  navigateToTab(tab: string): void {
    this.router.navigate(['/challenges'], {
      queryParams: { tab: tab === 'overview' ? null : tab },
      queryParamsHandling: 'merge' // ensures tab=null actually removes the param from URL
    });
  }

  /** Toggle expand/collapse for items with subsections (e.g. All Challenges). */
  toggleSubsections(item: { key: string; subsections?: unknown[] }): void {
    if (!item.subsections) return;
    this.expandedMenuKeys[item.key] = !this.expandedMenuKeys[item.key];
  }

  /** Only the item whose key exactly matches the current activeTab is active (strict, single selection). */
  isActive(item: { key?: string }): boolean {
    const key = item?.key;
    return typeof key === 'string' && key !== '' && this.activeTab === key;
  }

  trackByKey(_index: number, item: { key: string }): string {
    return item.key;
  }

  isParentActive(item: { key?: string; subsections?: { key: string }[] }): boolean {
    if (!item.subsections) return false;
    return item.subsections.some(sub => sub.key === this.activeTab);
  }

  /** Show subsections when expanded by toggle OR when a subsection is active. */
  shouldShowSubsections(item: { key?: string; subsections?: { key: string }[] }): boolean {
    if (!item.subsections) return false;
    return this.isParentActive(item) || !!this.expandedMenuKeys[item.key!];
  }
}

